import colors from "@/colors"

const Highcharts = require("highcharts")

require("highcharts/highcharts-3d")(Highcharts)
require("highcharts/highcharts-more")(Highcharts)
require("highcharts/modules/accessibility")(Highcharts)
require("highcharts/modules/drilldown")(Highcharts)
require("highcharts/modules/export-data")(Highcharts)
require("highcharts/modules/exporting")(Highcharts)

Highcharts.setOptions({
  exporting: { enabled: false },
  credits: { enabled: false },
  lang: { drillUpText: "<< Back", thousandsSep: "," },
  chart: {
    style: {
      fontFamily: "'Source Sans 3', ui-sans-serif",
    },
    backgroundColor: "transparent",
  },
  colors: [
    colors.blue[400],
    colors.orange[400],
    colors.yellow[400],
    colors.teal[400],
    colors.rose[400],
    colors.indigo[400],
    colors.fuchsia[400],
    colors.lime[400],

    colors.blue[600],
    colors.orange[600],
    colors.yellow[600],
    colors.teal[600],
    colors.rose[600],
    colors.indigo[600],
    colors.fuchsia[600],
    colors.lime[600],
  ],
  title: {
    style: {
      fontSize: "1rem",
      fontWeight: "500",
    },
  },
  subtitle: {
    style: {
      fontSize: "0.875rem",
      color: colors.gray[600],
    },
  },
  tooltip: {
    backgroundColor: "#ffffff",
    borderColor: colors.gray[300],
    borderRadius: 8,
    shadow: false,
    padding: 10,
    style: {
      fontSize: "0.875rem",
    },
  },
  legend: {
    itemStyle: {
      fontSize: "0.875rem", // text-sm
      fontWeight: 500,
      color: colors.gray[500],
    },
  },
  xAxis: {
    title: {
      style: {
        fontSize: "1rem",
        color: colors.gray[600],
      },
    },
    labels: {
      style: {
        fontSize: "0.875rem", // text-sm
        color: colors.gray[500],
      },
    },
  },
  yAxis: {
    title: {
      style: {
        fontSize: "1rem",
        color: colors.gray[600],
      },
    },
    labels: {
      style: {
        fontSize: "0.875rem", // text-sm
        color: colors.gray[500],
      },
    },
  },
  plotOptions: {
    series: {
      animation: false,
      dataLabels: {
        style: {
          fontSize: "0.875rem", // text-sm
          fontWeight: 600,
        },
      },
    },
  },
})

window.Highcharts = Highcharts

export default Highcharts
